"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _orderEntryFormConstants = require("../../../../../constants/sendOrder/orderEntryFormConstants");
var _buySellSelectors = require("../../../../../redux/selectors/buySellSelectors");
var _orderEntryActions = require("../../../../../redux/actions/orderEntryActions");
var _BuySellTabsComponent = _interopRequireDefault(require("./BuySellTabsComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    isBuySide: (0, _buySellSelectors.isBuySideBuySellFormSelector)(state)
  };
};
var mapDispatchToProps = {
  setBuyValue: function setBuyValue() {
    return (0, _reduxForm.change)('buySell', 'side', _orderEntryFormConstants.buyValue);
  },
  setSellValue: function setSellValue() {
    return (0, _reduxForm.change)('buySell', 'side', _orderEntryFormConstants.sellValue);
  },
  clearForm: _orderEntryActions.clearBuySellForm
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BuySellTabsComponent["default"]);